import React from "react";
import { useTranslation } from "react-i18next";

import Breadcrumb from "../../../../../../components/Generic/Breadcrump";
import { AutomaticSequence } from "./components/AutomaticSequence";
import { GeneralConfiguration } from "./components/GeneralConfiguration";
import { IntegrationConfiguration } from "./components/IntegrationConfiguration";
import { EmailConfiguration } from "./components/EmailConfiguration";
import { TermsAndCondition } from "./components/TermsAndCondition";

import useStyles from "./styles";

type Props = {
  permission?: {
    edit: boolean;
  };
};

const AutomationPage = (props: Props) => {
  const { permission } = props;
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <div className={classes.wrapper} data-cy="automationPage">
      {/* <header className="mb-4">
        <Breadcrumb
          items={[
            { title: translate("configurations") },
            {
              title: translate("automation"),
              color: "#465869",
              dataCy: "breadcrumbsSubTitle",
            },
          ]}
        />
      </header> */}
      <section>
        <AutomaticSequence permission={permission} />
        {/* TODO uncomment these lines when service is ready */}
        {/* <GeneralConfiguration />
        <EmailConfiguration />
        <IntegrationConfiguration />
        <TermsAndCondition /> */}
      </section>
    </div>
  );
};

export default AutomationPage;
